<template>
  <ValidationProvider name="beverage" :vid="vid" rules="required" v-slot="{ errors }" mode="passive" tag="div">
    <div class="radio-selection-container">
      <div
        class="radio-btn"
        v-for="option in options"
        :key="`${name}-${option.value}`.replace(/\s+/g, '_').toLowerCase()"
      >
        <input
          :id="`${name}-${option.value}`.replace(/\s+/g, '_').toLowerCase()"
          type="radio"
          v-model="innerValue"
          :name="name"
          :value="option.value"
          autocomplete="off"
        />
        <label class="text-left" :for="`${name}-${option.value}`.replace(/\s+/g, '_').toLowerCase()">
          <div class="d-inline">
            <svg class="beverage-icon primary-fill-svg">
              <use :href="require('@/assets/fa/beverages.svg') + getImageId(option.value)"></use>
            </svg>
          </div>
          {{ option.label }}
          <span class="float-right svgIcon primary-fill-svg">
            <slot name="icon">
              <!--Add the svgIcon to the slot if you are using your own-->
              <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20">
                <path
                  fill="#007bc7"
                  fill-rule="evenodd"
                  d="M18 10a8 8 0 1 1-16 0 8 8 0 0 1 16 0zm-8.925 4.236L15.01 8.3a.516.516 0 0 0 0-.73l-.73-.73a.516.516 0 0 0-.73 0l-4.84 4.841-2.26-2.26a.516.516 0 0 0-.73 0l-.73.73a.516.516 0 0 0 0 .73l3.355 3.355a.516.516 0 0 0 .73 0z"
                ></path>
              </svg>
            </slot>
          </span>
        </label>
      </div>
    </div>
  </ValidationProvider>
</template>
<script>
import { ValidationProvider } from 'vee-validate';

export default {
  name: 'BeverageRadio',
  components: {
    ValidationProvider,
  },
  props: {
    options: {
      type: Array,
      required: true,
    },
    vid: {
      type: Number,
    },
    value: {
      type: null,
    },
    name: {
      // name can be anything, It just has to be unqiue from another instance of this component in the same form.
      type: String,
      required: true,
    },
  },
  methods: {
    getImageId(name) {
      return this.imageArray.filter(item => item.name === name)[0].id;
    },
  },
  data() {
    return {
      innerValue: '',
      imageArray: [
        { id: '#water-drop', name: 'water' },
        { id: '#coffee-cup', name: 'coffee' },
        { id: '#tea', name: 'tea' },
        { id: '#pop', name: 'pop' },
        { id: '#iced-tea', name: 'iced_tea' },
        { id: '#apple-juice', name: 'apple_juice' },
        { id: '#orange-juice', name: 'orange_juice' },
        { id: '#no-beverage', name: 'no_beverage' },
        { id: '#pop', name: 'soda_water' },
        { id: '#pop', name: 'cola' },
        { id: '#pop', name: 'diet_cola' },
        { id: '#pop', name: 'lemon_soda' },
        { id: '#coffee-cup', name: 'decaf_coffee' },
        { id: '#coffee-cup', name: 'hot_chocolate' },
        { id: '#pop', name: 'root_beer' },
        { id: '#tea', name: 'decaf_tea' },
      ],
    };
  },
  watch: {
    // Handles internal model changes.
    innerValue(newVal) {
      this.$emit('input', newVal);
    },
    // Handles external model changes. Immediate = false to load value if a value is there.
    value: {
      immediate: true,
      handler(newVal) {
        this.innerValue = newVal;
      },
    },
  },
};
</script>
<style scoped lang="scss">
@import 'src/assets/scss/variables';
.radio-btn {
  cursor: pointer;
  padding-bottom: 8px;
  .beverage-icon {
    width: 20px;
    height: 20px;
  }

  label {
    display: block;
    position: relative;
    font-size: 16px;
    font-weight: bold;
    background: white;
    color: rgb(75, 88, 99);
    margin-bottom: 0;
    border-radius: 6px;
    box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.06);
    border: 1px solid #dae2ea;
    padding: 12px 30px 12px 17px;
    cursor: pointer;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    transition: border 0.25s ease;

    .svgIcon {
      display: none;
    }
  }

  input[type='radio'] {
    opacity: 0;
    position: absolute;
  }
  input[type='radio']:hover + label {
    background: $primary-light-background;
  }

  input[type='radio']:checked + label {
    background: $primary-light-background;
    border: 1px solid $primary;
    .svgIcon {
      display: block;
    }
  }
}
.svgIcon {
  position: absolute;
  right: 12px;
  top: 12px;
}
@media (min-width: 575px) {
  .radio-btn {
    width: 100%;
    break-inside: avoid;
  }
  .radio-selection-container {
    columns: 2;
    column-gap: 8px;
  }
}
</style>
